import React from 'react';

import Button from '../../../../../../library/button/button';
import AddProductButton from '../../../../../../components/add-product-button/add-product-button';
import FoundItLowerButton from '../../../../../../components/found-it-lower-button/found-it-lower-button';
import NeedItNow from '../../../../../../components/need-it-now/need-it-now';
import ProductQuantity from '../../../../../../components/product-quantity/product-quantity';
import QuantityDisclaimer from '../../../../../../components/quantity-disclaimer/quantity-disclaimer';
import ProductListCardPrice from '../../../product-list-card-price/product-list-card-price';

import {
  useMediaQuery,
  useMyStore
} from '../../../../../../shared/hooks/hooks';

import {
  getNormalizedProductType,
  isCanonicalProduct
} from '../../../../../../shared/utils/product/product';

import { ProductData } from '../../../../../../shared/types/graphql-types';
import { ProductItem } from '../../../../../../shared/types/product';

import './product-list-card-actions.scss';

interface ProductListCardActionsProps {
  defaultQuantity: number;
  onAddProductClick: (productItem: ProductItem) => void;
  onQuantityChange: (value: number) => void;
  onViewProductClick?: () => void;
  product: ProductData;
  productDetailUrl: string;
  quantity: number;
  totalQuantity: number;
}

function ProductListCardActions(props: ProductListCardActionsProps) {
  const {
    defaultQuantity,
    onAddProductClick,
    onQuantityChange,
    onViewProductClick,
    product,
    productDetailUrl,
    quantity,
    totalQuantity
  } = props;

  const { myStore } = useMyStore();
  const { isMinMd } = useMediaQuery();

  const { addToCartDisabled, stock } = product || {};
  const isCanonical = isCanonicalProduct(product);
  const productType = getNormalizedProductType(product);
  const showNeedItNow =
    !addToCartDisabled && stock?.availabilityMessageRank !== 1;
  const showAddToCart = !addToCartDisabled;

  function handleQuantityChange(e, updatedValue) {
    onQuantityChange(updatedValue);
  }

  if (!isCanonical && !showAddToCart && !isMinMd) return null;

  return (
    <div styleName="container">
      <div styleName="buy">
        <div styleName="price-info">
          <ProductListCardPrice
            hideInstantPromo
            product={product}
            quantity={quantity}
            totalQuantity={totalQuantity}
          />

          <FoundItLowerButton
            className="display-md"
            productItem={{
              product: product,
              quantity: quantity,
              totalQuantity: totalQuantity
            }}
            styleName="found-it-lower"
          />
        </div>

        {isCanonical ? (
          <Button
            href={productDetailUrl}
            isPrimary
            onClick={onViewProductClick}
            styleName="view-details-btn"
          >
            View Details
          </Button>
        ) : (
          <>
            {showAddToCart && (
              <>
                <ProductQuantity
                  defaultValue={defaultQuantity}
                  id="quantity"
                  isHorizontal
                  onBlur={handleQuantityChange}
                  onChange={handleQuantityChange}
                  showLabel
                  value={quantity}
                />

                <AddProductButton
                  onClick={onAddProductClick}
                  productItem={{ product, quantity, totalQuantity }}
                  styleName="add-to-btn"
                />
              </>
            )}
          </>
        )}
        <QuantityDisclaimer productType={productType} quantity={quantity} />
      </div>

      {showNeedItNow && (
        <div styleName="need-it-now">
          <NeedItNow
            phone={myStore?.address?.phone}
            productType={productType}
          />
        </div>
      )}
    </div>
  );
}

export default ProductListCardActions;
